module.exports = __webpack_public_path__ + "img/f2-01.cd5a88fb.png";